interface SegmentIconProps {
  color?: string
  width?: number
  height?: number
  style?: React.CSSProperties
}

const SegmentIcon = ({
  color = "white",
  width = 15,
  height = 15,
  style,
}: SegmentIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 81 109"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g clipPath="url(#clip0_695_15249)">
        <path
          d="M6.40137 -0.5V12.2041L19.0664 -0.351562L19.2129 -0.49707H26.7539L25.8916 0.358398L10.8184 15.3027L70.1885 15.3096L55.1211 0.363281L54.2598 -0.492188H61.7998L61.9463 -0.34668L74.6074 12.2119L74.6094 0.00976562V-0.490234H81.5V0.00976562L81.4883 109V109.5H74.5996V96.4033L61.5381 109.355L61.3916 109.5H53.8486L54.7109 108.645L69.623 93.8574L11.3672 93.8496L26.2803 108.646L27.1426 109.5H19.6016L19.4561 109.355L6.39062 96.3955V109.5H-0.5V109L-0.485352 0V-0.5H6.40137ZM11.4648 87.0078L69.5273 87.0146L40.5 58.2188L11.4648 87.0078ZM44.2695 54.4814L74.5986 84.5693L74.6055 24.4014L44.2695 54.4814ZM6.39258 84.5586L36.7285 54.4795L6.39941 24.3926L6.39258 84.5586ZM40.5 50.7422L69.334 22.1514L11.6738 22.1445L40.5 50.7422Z"
          fill={color}
          stroke={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_695_15249">
          <rect width="81" height="109" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default SegmentIcon
